import Vue from 'vue'
import App from '../../QC/CIDApp.vue'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
